import { render, staticRenderFns } from "./FeeImport.vue?vue&type=template&id=a830c1f8&"
import script from "./FeeImport.vue?vue&type=script&lang=js&"
export * from "./FeeImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports